import React from "react";
import { RouteProp } from "@react-navigation/native";
import { LazyQueryNetworkBoundrary } from "../../components/mobile/QueryNetworkBoundrary";
import { NavProp, ParamList } from "./TeamScheduleHistoryStack";
import { Box } from "arkh";
import { useLazyLoadQuery } from "react-relay";
import { graphql } from "relay-runtime";

import { TeamScheduleHistoryMasterList } from "./TeamScheduleHistoryMasterList";
import { TeamScheduleHistoryScreenCombinedQuery } from "./__generated__/TeamScheduleHistoryScreenCombinedQuery.graphql";
import { TeamScheduleHistoryDetail } from "./TeamScheduleHistoryDetail";

export function TeamScheduleHistoryScreenCombined(props: {
  navigation: NavProp<"TeamScheduleHistoryScreen">;
  route: RouteProp<ParamList, "TeamScheduleHistoryScreen">;
}) {
  return (
    <LazyQueryNetworkBoundrary>
      {(fk) => <TeamScheduleHistoryScreenC {...props} fetchKey={fk} />}
    </LazyQueryNetworkBoundrary>
  );
}

function TeamScheduleHistoryScreenC(props: {
  navigation: NavProp<"TeamScheduleHistoryScreen">;
  route: RouteProp<ParamList, "TeamScheduleHistoryScreen">;
  fetchKey: string;
}) {
  const data = useLazyLoadQuery<TeamScheduleHistoryScreenCombinedQuery>(
    graphql`
      query TeamScheduleHistoryScreenCombinedQuery(
        $teamId: ID!
        $first: Int
        $after: String
        $freq: RoutineScheduleType!
      ) {
        store {
          team(id: $teamId) {
            name
            ...TeamScheduleHistoryMasterList_team
          }
        }
      }
    `,
    {
      teamId: props.route.params.teamId,
      first: 20,
      freq: props.route.params.freq,
    },
    {
      fetchKey: props.fetchKey,
      fetchPolicy: "store-and-network",
    }
  );

  if (!data.store.team) {
    return null;
  }
  return (
    <Box color="background" style={{ flex: 1, flexDirection: "row" }}>
      <Box style={{ width: "40%", height: "100%" }}>
        <TeamScheduleHistoryMasterList
          onSelect={(id) => {
            props.navigation.setParams({
              currentId: id,
            });
          }}
          currentId={props.route.params.currentId ?? null}
          team={data.store.team}
        />
      </Box>
      <LazyQueryNetworkBoundrary newFetchKeyOnNavigation>
        {(fk) => (
          <TeamScheduleHistoryDetail
            id={props.route.params.currentId}
            teamId={props.route.params.teamId}
            fetchKey={fk}
          />
        )}
      </LazyQueryNetworkBoundrary>
    </Box>
  );
}
